<template>
  <v-col cols="12" sm="12">
    <v-col cols="6" sm="6">
      <v-toolbar-title>Contratista</v-toolbar-title>
      <br />
      <v-text-field
        v-model="buscar"
        :append-icon="'mdi-select-search'"
        label="Buscar Contratista por Id / Contratista / Descripciòn"
        dense
      ></v-text-field>
    </v-col>
    <v-data-table
      :headers="headers"
      :items="contratistas"
      item-key="idContratista"
      sort-by="idContratista"
      :search="buscar"
      :header-props="headerProps"
      :footer-props="footerProps"
      no-data-text="No se encontraron registros"
      no-results-text="No se encontraron registros en la búsqueda"
    >
      <!-- <template v-slot:[`item.Estado`]="{ item }">
        <v-chip :color="getColor(item.Estado)">
          {{ item.Estado == 1 ? "Activo" : "Inactivo" }}
        </v-chip>
      </template> -->

      <template v-slot:[`item.estado`]="{ item }">
        <v-chip :color="getColor(item.estado)">
          {{ getTextoEstado(item.estado) }}
        </v-chip>
      </template>

      <template v-slot:top>
        <v-toolbar flat>
          <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
          <v-spacer></v-spacer>
          <v-tooltip left color="indigo">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                elevation="10"
                small
                fab
                color="indigo"
                dark
                class="mx-2"
                @click="AbrirModal(0)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Armar Contratista</span>
          </v-tooltip>

          <v-dialog v-model="dialogDelete" max-width="800px">
            <v-card>
              <v-card-title class="text-h5"
                >¿Está seguro que desea eliminar esta Contratista?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip left color="blue">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              elevation="10"
              small
              fab
              color="blue"
              dark
              class="mx-2"
              @click="verDetalleCajon(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> mdi-eye </v-icon>
            </v-btn>
          </template>
          <span>Ver Detalle</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <insertContratista ref="abrirModalContratista"></insertContratista>
    <!-- <dialog-mensaje
      ref="dialogMensaje"
      @resultado="confirmarCierreContratista"
    /> -->
  </v-col>
</template>
<script>
//import dialogMensaje from "@/components/modalMensaje.vue";
//import insertContratista from "@/modulos/Cuadrilla/componentes/modalCuadrillas.vue";
import insertContratista from "@/modulos/Contratista/componentes/modalContratistas.vue";
import axios from "axios";
export default {
  components: {
    insertContratista,
    //dialogMensaje,
  },
  data: () => ({
    idCuadrillaEliminar: "",
    dialogDelete: false,
    contratistas: [],
    headers: [
      {
        text: "Id",
        align: "start",
        sortable: true,
        value: "idContratista",
        class: "black white--text",
      },
      { text: "Descripción", value: "descripcion", class: "black white--text" },
      {
        text: "Fecha de Asignacion",
        value: "fechaAsignacion",
        class: "black white--text",
      },
      { text: "Orden de Trabajo", value: "ord_ot", class: "black white--text" },
      { text: "Estado", value: "estado", class: "black white--text" },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        class: "black white--text",
      },
    ],
    headerProps: {
      sortByText: "Ordenar por",
    },
    other: [1, 20, 344, 44444],
    footerProps: {
      itemsPerPageText: "Registros por página",
      pageText: "{0}-{1} de {2}",
      itemsPerPageOptions: [5, 10, 20, 50, 100, { text: "Todos", value: -1 }],
    },
    buscar: "",
    cuadrillas: [],
    editedIndex: -1,
    editedItem: {
      idCuadrilla: "",
      descripcion: 0,
    },
    defaultItem: {
      idCuadrilla: "",
      descripcion: 0,
    },
  }),

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  mounted() {
    // Mostrar los datos en la consola
    this.getListarCuadrillaByContratista();
    this.getListarOTContratistas();
  },
  methods: {
    verDetalleCajon(datos) {
      console.log("Ingreso en ver detalle");
      console.log(datos);
      //this.$refs.insertCajon.abrirModalCajones(datos);
      this.$refs.abrirModalContratista.abrirModalContratistaMateriales(datos);
      //this.$refs.insertCajon.openModal(datos);
    },

    getColor(estado) {
      console.log("Ingreso en la funcion getCOlor");
      if (estado == 1) return "green";
      else if (estado == 0) return "red";
    },

    getTextoEstado(estado) {
      return estado === 1 ? "Activo" : "Inactivo";
    },

    async getListarOTContratistas() {
      this.url =
        this.$store.getters.urlBase + "OT/recuperarOTsContratista";

      var listacontratista = [];
      this.contratistas = listacontratista;

      await axios
        .get(this.url)
        .then((response) => {
          console.log("Respuesta de recuperarOTsContratista");
          console.log(response.data);
          this.contratistas = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      this.loadingButton = false;
    },

    async confirmarCierreCuadrilla(resultadoFinal) {
      //console.log("Ingreso en confirmar cierre ");
      if (resultadoFinal == true) {
        //console.log("Ingreso en el true del confirmar cierre");
        this.url = this.$store.getters.urlBase + "Cuadrilla/cerrarCuadrilla";

        // const config = {
        //   headers: {
        //     Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        //   },
        // };

        var obj = {
          idCuadrilla: this.idCuadrillaEliminar,
          idUsuario: this.$store.getters.usuario.user_id,
        };

        console.log("La direccion es: ");
        console.log(this.url);

        var respuesta = await axios
          .post(this.url, obj)
          .then((response) => {
            return response;
          })
          .catch(function () {
            return null;
          });

        console.log("Esto hay en el respuesta");
        console.log(respuesta);

        if (respuesta.status == 200) {
          this.mensajeDelDialog = respuesta.data;

          var mensajeDialog = "";
          if (this.mensajeDelDialog == true) {
            mensajeDialog = "Operacion Exitosa";
          } else {
            mensajeDialog = "Operacion Rechazada";
          }

          this.$refs.dialogMensaje.abrirMensajeDialog(
            mensajeDialog,
            1,
            this.mensajeDelDialog == true ? "green" : "red",
            "Informacion"
          );
        } else {
          console.log("Ingreso en el else de la respuesta");
          this.$refs.dialogMensaje.abrirMensajeDialog(respuesta.Error, 1);
          this.mensajeDelDialog = respuesta.Error;
          this.mensajeDelDialog = respuesta.Error.split("-");
          this.colorDialog = "red";
          this.dialog = true;
        }

        if (this.bandera == 1) {
          console.log("Ingresoe en la bandera 1 para ocultar el dialog");
          this.dialogForm = false;
        }

        this.$router.push("/Cuadrillas");
      }
    },

    abrirAsignarTareas(datos) {
      this.$router.push({
        name: "Asignar Tarea a Cuadrilla",
        params: { datos },
      });
    },
    AbrirModal(tipo) {
      console.log("Presiono abrir el modal");
      console.log(tipo);
      this.$refs.abrirModalContratista.openModal();
    },
    // AbrirModalModificacion(item) {
    //   this.$refs.abrirModalContratista.openModalModificacion(item);
    // },
    deleteItem(item) {
      this.editedIndex = this.cuadrillas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.cuadrillas.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    cerrarCuadrilla(datosCuadrilla) {
      this.idCuadrillaEliminar = datosCuadrilla.idCuadrilla;
      this.$refs.dialogMensaje.abrirMensajeDialog(
        "Desea cerrar la cuadrilla " + datosCuadrilla.idCuadrilla + " ?",
        2,
        "red",
        "Aviso"
      );
    },

    async getListarCuadrilla() {
      this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de cuadrilla es:");
        console.log(respuesta.data);
        this.cuadrillas = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    async getListarCuadrillaByContratista() {
      console.log("El contratista es");
      console.log(this.$store.getters.usuario.idContratista);

      if (this.$store.getters.usuario.idContratista == null) {
        this.$store.getters.usuario.idContratista == 2;
      }

      this.url =
        this.$store.getters.urlBase +
        "Cuadrilla?idContratista=" +
        this.$store.getters.usuario.idContratista;
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        // params: {
        //   idcontratista:
        //     this.$store.getters.usuario.idRol != 3
        //       ? this.contratistaSeleccion
        //       : this.$store.getters.idContratista,
        // },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de cuadrilla es:");
        console.log(respuesta.data);
        this.cuadrillas = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    async getRecuperarServicios() {
      this.url = this.$store.getters.urlBase + "Gang/servicios";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("Los servicios son");
        console.log(respuesta.data);
        //this.cuadrillas = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },
  },
};
</script>
